/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unused-state */
/* eslint-disable prefer-destructuring */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import has from 'lodash/has';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { css } from 'glamor';
import ScrollToBottom from 'react-scroll-to-bottom';
import { isCreateDownloadOpen } from '../../state/createDownloadDialog';
import { isPrePostRollOpen } from '../../state/prePostRollSelection';
import {
  resetClipList,
  updateClipsOrder,
  getClipList,
  selectIsInit,
  selectUserClips,
} from '../../state/clipList';
import { resetCurrentReviewingClip } from '../../state/currentReviewingClip';
import { resetCurrentEditingClipIndex } from '../../state/currentEditingClip';
import ClipItem from './ClipItem/index';
import { selectUserOrgsSecurityProfilesIds } from '../../../../state/user/userOrgRole';

const REFRESH_INTERVAL = 30000;

const ROOT_CSS = css({
  height: '90%',
  width: '100%',
});

const Container = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
`;

class ClipList extends PureComponent {
  setUpGetClipsInterval(assetId) {
    const {
      getClipList,
    } = this.props;

    let refreshJob;
    const { setInterval } = window;
    if (this.state) refreshJob = this.state.refreshJob;
    if (refreshJob) clearInterval(refreshJob);
    getClipList(assetId);

    const getState = () => this.state;
    this.setState({
      refreshJob: setInterval(async () => {
        const state = getState();
        if (!state || !state.lastModified || state.lastModified <= Date.now() - REFRESH_INTERVAL) {
          getClipList(assetId);
        }
      }, REFRESH_INTERVAL),
    });
  }

  componentDidUpdate(prevProps) {
    const { assetId } = this.props;
    if (assetId && (!prevProps.assetId || prevProps.assetId !== assetId)) {
      this.setUpGetClipsInterval(assetId);
    }
  }

  componentDidMount() {
    const { assetId } = this.props;
    if (assetId) this.setUpGetClipsInterval(assetId);
  }

  componentWillUnmount() {
    const { refreshJob } = this.state;
    const { clearInterval } = window;
    const {
      resetClipList,
      resetCurrentReviewingClip,
      resetCurrentEditingClipIndex,
    } = this.props;

    clearInterval(refreshJob);

    resetClipList();
    resetCurrentReviewingClip();
    resetCurrentEditingClipIndex();
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const {
      updateClipsOrder,
    } = this.props;

    updateClipsOrder(result.source.index, result.destination.index);
    this.setState({
      lastModified: Date.now(),
    });
  }

  shouldDisableDrag(clip) {
    if (clip.userId) return true;

    const { currentPlayingClip, currentReviewingClip, userClips } = this.props;
    const lastClipInList = userClips[userClips.length - 1];

    const hasUnfinishedClip = !lastClipInList.markInTime || !lastClipInList.markOutTime;
    const playCliplistActive = !!currentPlayingClip.index;
    const previewClipActive = !!currentReviewingClip.index;

    return hasUnfinishedClip || playCliplistActive || previewClipActive;
  }

  render() {
    const {
      userName, impersonationUser, selectIsInit, clips,
    } = this.props;

    let useUser = userName;
    if (impersonationUser) {
      useUser = impersonationUser.displayName;
    }
    return (
      <ScrollToBottom className={ROOT_CSS}>
        <DragDropContext onDragEnd={(e) => this.onDragEnd(e)}>
          <Droppable droppableId="droppable" isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
            {(provided) => (
              <Container id="ClipList" {...provided.droppableProps} ref={provided.innerRef}>
                {selectIsInit ? (clips.map((clip, index) => {
                  const { id } = clip;
                  return (
                    <Draggable
                      key={`clip-${index}`}
                      draggableId={`clip-${index}`}
                      index={index}
                      isDragDisabled={this.shouldDisableDrag(clip)}
                    >
                      {(provided) => (
                        <ClipItem
                          clip={clip}
                          innerRef={provided.innerRef}
                          provided={provided}
                          key={id}
                          id={id}
                          clipIndex={index}
                        />
                      )}
                    </Draggable>
                  );
                })) : <></>}
                {provided.placeholder}
              </Container>
            )}
          </Droppable>
        </DragDropContext>
      </ScrollToBottom>
    );
  }
}

ClipList.defaultProps = {
  impersonationUser: null,
};

ClipList.propTypes = {
  userClips: PropTypes.array.isRequired, // supplied from Redux
  clips: PropTypes.array.isRequired, // supplied from Redux
  updateClipsOrder: PropTypes.func.isRequired, // supplied from Redux
  resetClipList: PropTypes.func.isRequired, // supplied from Redux
  resetCurrentReviewingClip: PropTypes.func.isRequired, // supplied from Redux
  resetCurrentEditingClipIndex: PropTypes.func.isRequired, // supplied from Redux
  currentPlayingClip: PropTypes.object.isRequired, // supplied from Redux
  currentReviewingClip: PropTypes.object.isRequired, // supplied from Redux
  userName: PropTypes.string.isRequired, // supplied from Redux
  assetId: PropTypes.string, // supplied from Redux
  user: PropTypes.object.isRequired, // supplied from Redux
  impersonationUser: PropTypes.object, // supplied from Redux
  userOrgsSecurityProfilesIds: PropTypes.array.isRequired, // supplied from Redux
  isCreateDownloadOpen: PropTypes.func.isRequired, // supplied from Redux
  isPrePostRollOpen: PropTypes.func.isRequired, // supplied from Redux
  getClipList: PropTypes.func.isRequired, // supplied from Redux
  selectIsInit: PropTypes.bool.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  userClips: selectIsInit(state) ? selectUserClips(state.clipList?.allClips) : [],
  clips: selectIsInit(state) ? state.clipList?.allClips : [],
  currentPlayingClip: state.currentPlayingClip,
  currentReviewingClip: state.currentReviewingClip,
  assetId: state.clipperMediaContent?.assetId,
  userName: state.user?.userOrgRole?.loginAs?.userInfo?.displayName ?? '',
  user: state.user?.userOrgRole?.loginAs?.userInfo ?? null,
  userOrgsSecurityProfilesIds: selectUserOrgsSecurityProfilesIds(state),
  selectIsInit: selectIsInit(state),
});

const mapDispatchToProps = {
  updateClipsOrder,
  resetClipList,
  resetCurrentReviewingClip,
  resetCurrentEditingClipIndex,
  isCreateDownloadOpen,
  isPrePostRollOpen,
  getClipList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClipList);
